import React from 'react';

import Card from '../../card/Card';
import { IVideo } from '../../../../typings/hlroom';

export const mapVideoToCard = (video: IVideo, navFilterallVisibility?: boolean, appType?: string) => (
  <Card
    key={video.asset_id}
    assetId={video.asset_id}
    title={video.title}
    modifyDate={video.modify_date}
    duration={video.duration}
    videoStill={video.video_still}
    channel={video.channel}
    subChannel={video.subchannel}
    subSubChannel={video.sub_subchannel}
    navFilterallVisibility={navFilterallVisibility}
    appType={appType}
  />
);

export const mapVideoToCardIsMenuOpen = (video: IVideo, appType?: string) => (
  <Card
    key={video.asset_id}
    assetId={video.asset_id}
    title={video.title}
    modifyDate={video.modify_date}
    duration={video.duration}
    videoStill={video.video_still}
    channel={video.channel}
    subChannel={video.subchannel}
    subSubChannel={video.sub_subchannel}
    isMenuOpen
    navFilterallVisibility={false}
    appType={appType}
  />
);
